import styled from 'styled-components'
import { Button, Box, Flex, getPaletteColor } from 'pcln-design-system'

export const FilterBarSection = styled(Flex)`
  position: fixed;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2;
  background-color: ${getPaletteColor('primary.base')};
  width: 248px;
  height: 48px;
  text-align: center;
  align-items: center;
  justify-content: center;

  a {
    text-decoration: none;
  }
  ${props => props.theme.flyQueries.desktop} {
    display: none;
  }
`

export const IconButton = styled(Button)`
  width: 100%;
  height: 48px;
  font-size: 16px;
  font-weight: 600;

  svg,
  span {
    vertical-align: middle;
  }
`

// TODO: this could be an actual component
export const FilterBarTabs = styled(Flex)`
  width: 100%;
  z-index: 2;
  overflow-x: scroll;
  background-color: ${getPaletteColor('background.lightest')};
  a {
    text-decoration: none;
  }
  ${props => props.theme.flyQueries.desktop} {
    display: none;
  }
`

/* eslint-disable sonarjs/no-identical-functions */
export const FilterTab = styled(Box)`
  font-size: 12px;
  flex-grow: 1;
  line-height: 16px;
  padding: 12px 0;

  text-align: center;
  background-color: ${getPaletteColor('background.lightest')};
  color: ${props => getPaletteColor('text.lightest')(props)};
  cursor: pointer;
  text-align: center;
  text-transform: 'uppercase';
  &:first-of-type {
    border-left: none;
  }
`
/* eslint-enable sonarjs/no-identical-functions */
